<template>
  <v-container fluid class="white py-0">
    <v-row class="text-center">
      <v-col class="pa-10 pt-12 my-12 justify-center">
        <h3 class="display-1 font-weight-light">
          <span class="poppins">"Foi intenso, curador e maravilhoso."</span>
        </h3>
        <div class="body-2 pt-1 font-weight-bold justify-center text--center">
          <span class="barlow">- Ester Checchetto, Psicanalista</span>
        </div>
      </v-col>
    </v-row>
    
    <v-row id="frases" class="">
      <v-col 
        cols="12" md="6" 
        class="pa-0"
        height="100%"
        :order="$vuetify.breakpoint.smAndDown ? 1 : 0"
      >
        <v-img
          class="fill-height" 
          :src="getImgUrl(video)"
          @click.stop="dialog = true"
          style="cursor: pointer;"
        ></v-img>
      </v-col>
      <v-col cols="12" md="6" 
        class="white--text black pt-8 pb-12"
        :class="{
          'px-12': $vuetify.breakpoint.mdAndUp,
          'px-8': $vuetify.breakpoint.smAndDown,
        }"
      >
        <h2 class="display-2 font-weight-bold pt-3">
          <span class="barlow white--text">Quão disposto você está a resgatar o puro ouro que existe dentro de você?</span>
        </h2>
        <v-divider class="primary my-4" style="width: 50px; border: 2px solid"></v-divider>
        <div class="grey--text text--lighten-2 title font-weight-light pt-1">
          <span class="poppins">Convite especial de Tadeu Belfort Júnior</span>
        </div>
        <v-img
          class=""
          :src="getImgUrl($vuetify.breakpoint.mdAndUp ? seta : setaMobile)"
          max-width="200"
          :style="$vuetify.breakpoint.mdAndUp ? 'left: -70px' : 'top: 10px'"
        ></v-img>
      </v-col>
    </v-row>

    <v-row class="">
      <v-col cols="12" md="6"
        class="black--text white pt-8 pb-12"
        :class="{
          'px-12': $vuetify.breakpoint.mdAndUp,
          'px-8': $vuetify.breakpoint.smAndDown,
        }"
      >
        <h2 class="display-2 font-weight-bold pt-3">
          <span class="barlow black--text">Plenitude é ter a coragem para viver o melhor que sua vida pode oferecer</span>
        </h2>
        <v-divider class="primary my-4" style="width: 50px; border: 2px solid"></v-divider>
        <div class="black--text title font-weight-light pt-1">
          <span class="poppins">Luz e Sombra é um processo único de dois dias intensos, profundos e transformadores. Você merece viver o melhor!</span>
        </div>
        <v-btn
          x-large outlined
          color="primary"
          class="mt-6"
          :block="$vuetify.breakpoint.smAndDown"
          @click="$vuetify.goTo('#mais-info')"
        >
          <span class="font-weight-bold">Transforme a Sua Vida</span>
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" class="pa-0">
        <v-img
          class="fill-height" 
          :src="getImgUrl(imagem)"
        ></v-img>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="800"
    >
      <iframe v-if="dialog" id="iframeid" ref="iframe" width="100%" height="450" src="https://www.youtube.com/embed/ruNkNfxLPbs?autoplay=1&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-dialog>

  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      video: 'video-frase.jpg',
      imagem: 'frase.jpg',
      seta: 'seta.png',
      setaMobile: 'seta-mobile.png'
    }
  },
  methods: {
    getImgUrl(i) {
      return require('../assets/img/'+i)
    },
  }
}
</script>